import { format } from "date-fns"

export const NOTIFICATIONS_INITIAL_QUERY_STATE = {
  onlyNotRead: false,
  Types: [],
  SubTypes: [],
  Categories: [],
  skipCount: 0,
  maxResultCount: 10,
}

export const MONTHS = (t: $TSMigrationFixMe) => {
  return {
    January: `${t("months.january")}`,
    February: `${t("months.february")}`,
    March: `${t("months.march")}`,
    April: `${t("months.april")}`,
    May: `${t("months.may")}`,
    June: `${t("months.june")}`,
    July: `${t("months.january")}`,
    August: `${t("months.july")}`,
    September: `${t("months.september")}`,
    Octuber: `${t("months.octuber")}`,
    November: `${t("months.november")}`,
    December: `${t("months.december")}`,
  }
}

const mapNotificationsMonth = (
  monthYear: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  const month = monthYear.slice(0, 2)
  const year = monthYear.slice(-4)
  const date = new Date(`${month}/01/${year}`)

  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
  return MONTHS(t)[format(date, "MMMM")]
}

export const mapNotifications = (
  notifications: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  const groupedNotificationsObject = notifications.reduce(
    (acc: $TSMigrationFixMe, notification: $TSMigrationFixMe) => {
      const monthYear = format(new Date(notification.creationTime), "MM/yyyy")
      const date = format(new Date(notification.creationTime), "dd/MM/yyyy")
      return {
        ...acc,
        [monthYear]: {
          ...acc[monthYear],
          [date]: [...(acc[monthYear]?.[date] || []), notification],
        },
      }
    },
    {}
  )

  const groupedNotificationsArray = Object.keys(
    groupedNotificationsObject
    // @ts-expect-error TS(2769): No overload matches this call.
  ).reduce((notificationsAcc, monthYear) => {
    const dates = Object.keys(groupedNotificationsObject[monthYear])
    const month = mapNotificationsMonth(monthYear, t)
    const items = dates.reduce(
      // @ts-expect-error TS(2769): No overload matches this call.
      (itemsAcc, date) => [
        ...itemsAcc,
        { date, notifications: groupedNotificationsObject[monthYear][date] },
      ],
      []
    )
    return [...notificationsAcc, { monthYear, month, items }]
  }, [])

  return groupedNotificationsArray
}

export const notificationsQueryState = (queryState: $TSMigrationFixMe) => {
  const {
    Types,
    SubTypes,
    Categories,
    skipCount,
    maxResultCount,
    onlyNotRead,
  } = queryState

  return {
    Types,
    SubTypes,
    Categories,
    skipCount,
    maxResultCount,
    ...(onlyNotRead && { Read: false }),
  }
}
